import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  TextField,
  Typography,
  FormHelperText,
} from "@mui/material";

function ClientSatisfactionCard({
  title = "Satisfaction Rating",
  rating = 0,
  remarks = "",
  onRatingChange,
  onRemarksChange,
  ratingError,
  remarksLabel = "Additional Comments / Remarks",
  emptyRatingText = "(1 – lowest, 5 – highest)",
  showRemarks = true,

  readOnly = false,
  disabled = false,
}) {
  const isLocked = readOnly || disabled;

  return (
    <Grid item xs={12}>
      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardHeader
          title={
            <Typography
              variant="subtitle2"
              sx={{ fontWeight: "bold", textTransform: "uppercase" }}
            >
              {title}
            </Typography>
          }
          sx={{ px: 2, pt: 2, pb: 0 }}
        />

        <CardContent sx={{ px: 2, pb: 2 }}>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {emptyRatingText}
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
              mb: 2,
              flexWrap: "wrap",
            }}
          >
            {[1, 2, 3, 4, 5].map((n) => {
              const selected = Number(rating) === n;

              return (
                <Button
                  key={n}
                  type="button"
                  onClick={() => {
                    if (!isLocked) {
                      onRatingChange?.(n);
                    }
                  }}
                  disabled={isLocked}
                  sx={{
                    fontSize: "1.25rem",
                    minWidth: "40px",
                    width: "40px",
                    height: "40px",
                    p: 0,
                    borderRadius: "50%",
                    transition: "all 0.2s ease-in-out",
                    bgcolor: selected ? "primary.main" : "transparent",
                    color: selected ? "common.white" : "text.secondary",
                    border: selected ? "2px solid" : "1px solid",
                    borderColor: selected ? "primary.main" : "divider",
                    opacity: isLocked ? 1 : undefined,
                    "&:hover": {
                      bgcolor: selected ? "primary.dark" : "action.hover",
                    },
                  }}
                >
                  {n}
                </Button>
              );
            })}
          </Box>

          {ratingError ? (
            <FormHelperText error sx={{ mb: showRemarks ? 2 : 0 }}>
              {ratingError}
            </FormHelperText>
          ) : null}

          {showRemarks && (
            <TextField
              fullWidth
              multiline
              rows={4}
              label={remarksLabel}
              value={remarks || ""}
              onChange={(e) => onRemarksChange?.(e.target.value)}
              size="small"
              disabled={isLocked}
              InputLabelProps={{ shrink: true }}
            />
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}

export default ClientSatisfactionCard;